import React from 'react'

const Resume = () => {
  return (
    <section id="resume" class="resume">
            <div class="container">
                <div class="section-title">
                    <h2>Resume</h2>
                    <p>Complete Details About My Work Experience And Education.</p>
                </div>
                <div className="row">
                    <div class="col-lg-6" data-aos="fade-up">
                        <h3 class="resume-title">Summary</h3>
                        <div class="resume-item pb-0">
                            <h4>Saqib Diar</h4>
                            <p><em>Innovative and deadline-driven Developer with 4+ years of experience designing
                                    and developing user-centered digital/print marketing websites from initial concept
                                    to final, polished deliverable.</em></p>
                            <ul>
                                <li>Ring Road, Peshawar, Pakistan</li>
                                <li>+92 324 9088331</li>
                                <li>saqibdiar.uet@gmail.com</li>
                            </ul>
                        </div>
                        <h3 class="resume-title">Education</h3>
                        <div class="resume-item">
                            <h4>Degree in Computer Science</h4>
                            <h5>2018 - 2022</h5>
                            <p><em>University of Engneering and Technology, Peshawar (UETP)</em></p>
                            <p>Completed my degree in Computer Science from University of Engneering and Technology Peshawar.</p>
                        </div>
                        <div class="resume-item">
                            <h4>Final Year Project (FYP)</h4>
                            <h5>2022</h5>
                            <p><em>The final year project were based on CMS(complaint management system) in which I used:</em></p>
                            <p>The Tools :</p>
                           <ul>
                           <li>React JS ( Front-End )</li>
                            <li>Node JS ( Back-End ) using Express JS</li>
                            <li>Mongo DB ( database )</li>
                           </ul>
                            <p></p>
                        </div>
                    </div>
                    <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                        <h3 class="resume-title">Professional Experience</h3>
                        <div class="resume-item">
                            <h4>React JS front-end developer</h4>
                            <h5>2018 - present</h5>
                            <p><em>Remote</em></p>
                            <ul>
                                <li>Lead in the design, development, and implementation of the graphic, layout, and
                                    production communication materials</li>
                                <li>Delegate tasks to the 2 members of the design team and provide counsel on all
                                    aspects of the project.</li>
                                <li>Supervise the assessment of all coding materials in order to ensure quality and
                                    accuracy of the project.</li>
                                <li>Oversee the efficient use of production project containing 25+ pages and a number of sections.</li>
                                <li>Customized the designs to become pixel-perfect and responsive on every device.</li>
                            </ul>
                        </div>
                        <div class="resume-item">
                            <h4>node js back-end developer</h4>
                            <h5>2019 - present</h5>
                            <p><em></em></p>
                            <ul>
                                <li>Developed numerous marketing websites (eCommerce, Portfolio, Blog, Personal, Niche, Forum, Membership
                                    and advertisements).</li>
                                <li>Managed up to 5 projects or tasks at a given time while under pressure</li>
                                <li>Recommended and consulted with clients on the most appropriate Back-End developer.</li>
                                <li>Created 40+ API's in a single big project and connected with Front-End</li>
                                <li>Created projects using MongoDB (database) and express js.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default Resume